import { Component, HostBinding, OnInit,OnDestroy } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbCalendar, NgbDatepickerConfig, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { UsuarioService } from '@account/usuario.service';
import { EstadoRefacturacion } from '@shared/enums/estadoRefacturacion';
import { Motivo } from '@shared/enums/Motivo';
import { Aerovale } from '@shared/models/despacho/Aerovale';
import { ErrorModel } from '@shared/models/ErrorModel';
import { Comprobante } from '@shared/models/facturacion/Comprobante';
import { Factura } from '@shared/models/facturacion/Factura';
import { RefacturacionFactura } from '@shared/models/facturacion/RefacturacionFactura';
import { MessageService } from '@shell/message.service';
import { ComprobanteService } from '../comprobante.service';
import { FacturacionService } from '../facturacion.service';
import { ItemMultiFiltro } from '@shared/multifiltro/ItemMultifiltro';
import { DatePipe } from '@angular/common';
import { SharedService } from '@shared/shared.service';
import { TipoModalObservacion } from "@shared/enums/TipoModalObservacion";
import { MotivosObservacionesComponent } from "@shared/components/motivos-observaciones/motivos-observaciones.component";
import { ActivatedRoute } from '@angular/router';
import { TipoSolapaRefacturacion } from '@shared/enums/TipoSolapaRefacturacion';
import { CondicionVenta } from '@shared/enums/condicionVenta';
import { RolesService } from '@shared/services/roles.service';
import { TipoMovimientoPipe } from '@shared/pipes/tipo-movimiento.pipe';
import { AerovaleDetalle } from '@shared/models/despacho/AerovaleDetalle';
import { TipoSolicitudRefacturacion } from '@shared/enums/facturacion/TipoSolicitudRefacturacion';
import { AerovalesService } from '@despacho/aerovales.service';
import { AerovaleNumeroPipe } from '@shared/pipes/aerovale-numero.pipe';

@Component({
  selector: 'app-refacturacion-historial',
  templateUrl: './refacturacion-historial.component.html',
  styleUrls: ['./refacturacion-historial.component.css']
})
export class RefacturacionHistorialComponent implements OnInit,OnDestroy {

  @HostBinding('class.changed')

  facturaPrefijoMultiFiltro: ItemMultiFiltro[] = [];
  facturaNroMultiFiltro: ItemMultiFiltro[] = [];
  tipoMultiFiltro: ItemMultiFiltro[] = [];
  clienteMultiFiltro: ItemMultiFiltro[] = [];
  estadoMultiFiltro: ItemMultiFiltro[] = [];
  motivoMultifiltro: ItemMultiFiltro[] = [];
  solicitadoMultiFiltro: ItemMultiFiltro[] = [];
  validadorMultiFiltro: ItemMultiFiltro[] = [];
  revisadoMultiFiltro: ItemMultiFiltro[] = [];
  aprobadoMultiFiltro: ItemMultiFiltro[] = [];
  tipoSolicitudMultiFiltro: ItemMultiFiltro[] = [];

  tablaComprobantes: UntypedFormGroup;
  tituloFactura: string;
  tituloAerovale: string;

  facturaCalculada: Factura[];
  facturaObtenida: Comprobante;
  previsualizacion: boolean = false;

  aerovalesFiltrados: Aerovale[] = [];

  facturas: RefacturacionFactura[] = [];
  facturasFiltradas: RefacturacionFactura[] = [];
  facturasFiltradosMultifiltro: RefacturacionFactura[];
  previsualizando: boolean = false;
  previsualizandoAerovale: boolean = false;

  fechaFormControlDesdeHasta = new UntypedFormControl();
  modelDesde: NgbDateStruct;
  modelHasta: NgbDateStruct;
  startDate: Date;
  endDate: Date;
  buscando: boolean = false;
  mensajeSpinner: string = "D e s c a r g a n d o";
  obteniendoHistorial = true;
  procesandoExport: boolean = false;
  codigoAeroplanta: string;

  estadosRefacturacion = Object.keys(EstadoRefacturacion).filter(key => isNaN(Number(key)));
  estados: any[] = [];

  busquedaFormControl = new UntypedFormControl();
  change$: Subscription;
  errorAerovales: boolean = false;
  botonAnular: boolean = false;
  itemSeleccionado: number = null;

  isHistorialRefacturacion: boolean = false;
  CondicionVenta = CondicionVenta;
  motivo = Motivo;

  aerovaleDetalle: AerovaleDetalle = null;
  aerovaleDetalleNuevo: AerovaleDetalle = null;

  constructor(private formateadorDeFechas: NgbDatepickerConfig,
    private usuarioService: UsuarioService,
    private calendar: NgbCalendar,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private fb: UntypedFormBuilder,
    private comprobanteService: ComprobanteService,
    public facturacionService: FacturacionService,
    private messageService: MessageService,
    private datePipe: DatePipe,
    private router: ActivatedRoute,
    private sharedService: SharedService,
    private rolesService: RolesService,
    private tipoMovimientoPipe: TipoMovimientoPipe,
    private aerovaleService: AerovalesService,
    private aerovaleNumeroPipe: AerovaleNumeroPipe
    ) {
      this.change$ = sharedService.aeroplantaSeleccionada.subscribe(()=>{
        this.cambiarDeAeroplanta();
      });

      this.router.queryParams.subscribe((params) => {
        const solapaHistorialRefacturacion  = params['tipo'] as string;
        this.isHistorialRefacturacion = Number(solapaHistorialRefacturacion) === TipoSolapaRefacturacion.HistorialRefacturacion;
      });  
  }

  // hooks

  ngOnInit() {
    this.estados = [];
    this.estadosRefacturacion.forEach((e, i) => this.estados.push({
      valor: i,
      descripcion: e,
      seleccionado: false
    }));
    this.tablaComprobantes = this.fb.group({
      aerovalesFiltrados: new UntypedFormArray([])
    });
    this.addCheckboxes();

    this.codigoAeroplanta = this.usuarioService.getAeroplantaActual().codigoAeroplanta;

    this.botonAnular = false;
    this.mensajeSpinner = "C a r g a n d o . . .";

    this.modelDesde = this.calendar.getToday();
    this.modelHasta = this.calendar.getToday();

    this.dosMesesAtras(this.modelDesde.month);

    const inicio: any = { day: 1, month: 1, year: 2019 };
    this.formateadorDeFechas.minDate = inicio;
    const fin: any = { day: this.modelHasta.day, month: this.modelHasta.month, year: this.modelHasta.year };
    this.modelHasta = this.calendar.getToday();
    this.formateadorDeFechas.maxDate = fin;

    this.modelDesde = this.calendar.getToday();
    this.reinicioFechaInicioFechaFin();
    this.getHistorialporRango(this.startDate, this.endDate);
  }

  ngOnDestroy() {
    this.change$.unsubscribe();
    this.aerovalesFiltrados = [];
  }



  // form

  filtrarFacturas() {
    this.facturasFiltradas = this.facturas.filter(a => {
      let agregar = true;
      if (this.busqueda.value) {
        agregar = a.factura.razonSocialCliente.toLowerCase().indexOf(this.busqueda.value.toLowerCase()) > -1;

        agregar = agregar || (this.aerovaleNumeroPipe.transform(a.aerovaleNumero).toString() && this.aerovaleNumeroPipe.transform(a.aerovaleNumero).toString().toLocaleLowerCase().indexOf(this.busqueda.value.toLocaleLowerCase()) > -1);

        agregar = agregar || (this.datePipe.transform(a.fechaHora, "d/MM/y").indexOf(this.busqueda.value) > -1);
      }
      // filtro por estado
      if (this.estados.some(b => b.seleccionado))
        agregar = agregar && this.estados.some(
          b => (b.seleccionado && b.valor == a.estado));

      return agregar;
    });

    this.filtrarFacturasMulti();
  }

  fechaDesdeMayorQueHasta() {
    let esMayor: boolean = false;
    this.startDate = new Date(this.modelDesde.year, this.modelDesde.month - 1, this.modelDesde.day);
    this.endDate = new Date(this.modelHasta.year, this.modelHasta.month - 1, this.modelHasta.day);
    if (this.startDate > this.endDate) { esMayor = true; }
    return esMayor;
  }


  reinicioFechaInicioFechaFin() {
    this.startDate = new Date(this.modelDesde.year, this.modelDesde.month - 1, this.modelDesde.day);
    this.endDate = new Date(this.modelHasta.year, this.modelHasta.month - 1, this.modelHasta.day);
    this.endDate.setHours(23, 59, 59, 99);
  }

  buscarDesdeHasta() {
    this.mensajeSpinner = "C a r g a n d o . . .";
    this.buscando = true;
    this.reinicioFechaInicioFechaFin();
    this.getHistorialporRango(this.startDate, this.endDate);
  }


  limpiarCampos() {
    this.aerovalesFiltrados = [];
    this.spinner.hide("spinnerGrafico");
    this.spinner.hide("spinnerDetalle");
    this.buscando = false;
    this.busquedaFormControl.reset();
    this.modelDesde = this.calendar.getToday();
    this.modelHasta = this.calendar.getToday();
    this.estados = [];
    //limpio filtro estados
    for (const estado of this.estados) {
      estado.seleccionado = false;
    }
  }

  cambiarDeAeroplanta() {
    this.limpiarCampos();
    this.ngOnInit();
  }

  private addCheckboxes() {
    // reinicio el formulario
    this.tablaComprobantes.setControl('aerovalesFiltrados', this.fb.array([]));
    this.aerovalesFiltrados.map((o, i) => {
      const control = new UntypedFormControl(i === 0); // if first item set to true, else false
      control.setValue(o);
      (this.tablaComprobantes.controls.aerovalesFiltrados as UntypedFormArray).push(control);
    });
  }


  dosMesesAtras(mes) {

    if (mes == 1) {
      this.modelDesde.month = 11;
      this.modelDesde.year -= 1;
    }
    if (mes == 2) {
      this.modelDesde.month = 12;
      this.modelDesde.year -= 1;
    }
    if (mes != 1 && mes != 2) {
      this.modelDesde.month -= 2;
    }
  }

  obtenerTipoSolicitudRefacturacion(data: any) {
    const textoTipoSolicitud = TipoSolicitudRefacturacion[data?.tipoSolicitud] ?? 'Tipo desconocido';
    const esReemplazo = data.tipoSolicitud === TipoSolicitudRefacturacion.Reemplazo;
    const aerovaleAprobado = (data.aerovaleNuevoPrefijo ?? 0) !== 0 || (data.aerovaleNuevoNumero ?? 0) !== 0;
    if (esReemplazo && aerovaleAprobado) {
      return `${textoTipoSolicitud}\n(${data.aerovaleNuevoPrefijo}-${data.aerovaleNuevoNumero})`;
    }

    return textoTipoSolicitud;
  }

  // llamadas al service


  obtenerFacturaCalculada(remitos: string[]) {
    this.previsualizacion = false;
    this.comprobanteService.obtenerFacturaCalculada(remitos)
      .subscribe(result => {
        this.facturaCalculada = result;
        this.previsualizacion = true;
      })

  }

  verObservaciones(motivos: string) {
    const modalRef = this.modalService.open(MotivosObservacionesComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.motivos = motivos;
    modalRef.componentInstance.titulo = "Observaciones";
    modalRef.componentInstance.tipoObservacion = TipoModalObservacion.Refacturacion;
  }


  verComparativasFacturas(content, s: RefacturacionFactura, index) {
    this.previsualizando = true;
    this.itemSeleccionado = index;
    this.tituloFactura = 'Factura: ' + s.factura.prefijo + '-' + s.factura.numeroComprobante + ' Fecha: ' + new Date().toLocaleDateString();
    this.comprobanteService.obtenerComprobantePorPrefijoNumeroTipo(s.factura.prefijo, s.factura.numeroComprobante, s.factura.tipoMovimiento)
      .subscribe(result => {
        this.facturaObtenida = result;
        if (result != null) {
          this.facturacionService.getNuevoComprobante(s.id, s.esRefacturacionTotal)
            .subscribe(result => {
              this.facturaCalculada = result;
              this.previsualizando = false;
              this.itemSeleccionado = -1;
              this.modalService.open(content, { windowClass: 'custom-modal', centered: true, size: 'lg' });
            }, (err: ErrorModel) =>{
              this.previsualizando = false;
              this.itemSeleccionado = -1;
              this.messageService.showErrorMessage('Hubo un error al obtener la comparativa. ' + err.description + ' ' + err.message);
            });
        }
        else {
          this.previsualizando = false;
          this.itemSeleccionado = -1;
          s.factura.loadIcon = false;
          this.facturaObtenida = null; //se limpia el comprobante.
        }
      }, (err: ErrorModel) =>{
        this.previsualizando = false;
        this.itemSeleccionado = -1;
        this.messageService.showErrorMessage('Hubo un error al obtener la comparativa. ' + err.description + ' ' + err.message);
        });
  }

  handleSpinner(show: boolean) {
    show ? this.spinner.show('spinnerGrafico') : this.spinner.hide('spinnerGrafico');
    this.obteniendoHistorial = show;
  }

  getHistorialporRango(fechaInicio: Date, fechaFin: Date) {
    this.aerovalesFiltrados = [];
    this.handleSpinner(true);
    const desde: string = this.sharedService.formatDate(fechaInicio.getFullYear(), fechaInicio.getMonth() + 1, fechaInicio.getDate(), 0, 0);
    const hasta: string = this.sharedService.formatDate(fechaFin.getFullYear(), fechaFin.getMonth() + 1, fechaFin.getDate(), 23, 59);
    this.facturacionService.getFiltrarSegunReporte(this.isHistorialRefacturacion, desde, hasta).subscribe(result => {
      this.facturas = result;
      this.facturasFiltradas = this.isHistorialRefacturacion
        ? this.facturas
        : this.filtrarHistorialFacturas();
      this.agregarMotivoRechazo(this.facturasFiltradas);
      this.handleSpinner(false);
      this.filtrarFacturasMulti();
    }, () => {
      this.errorAerovales = true;
      this.handleSpinner(false);
    });
  }

  agregarMotivoRechazo(facturas: RefacturacionFactura[]) {
    facturas.forEach(f => {
      if (f.motivoRechazo != null) {
        f.detalle = f.detalle
          ? `${f.detalle}\n\nMotivo Rechazo: ${f.motivoRechazo}`
          : f.motivoRechazo;
      }
    });
  }

  filtrarHistorialFacturas(): RefacturacionFactura[] {
    return this.facturas.filter(f => {
        const facturas =
          f.codigoAeroplantaAerovale === this.codigoAeroplanta &&
          f.motivo === Motivo.Despacho;

        return facturas;
      }
    );
  }

  filtrarFacturasMulti(){
    if (this.facturasFiltradas != null) {

      this.facturasFiltradosMultifiltro = this.facturasFiltradas.filter(f => {
        let mostrar = true;

        if (this.facturaPrefijoMultiFiltro.some(elemento => elemento.seleccionado)) {
          mostrar = mostrar && (
            this.facturaPrefijoMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => elementoAux.id == f.factura.prefijo.toString())
          );
        }

        if (this.facturaNroMultiFiltro.some(elemento => elemento.seleccionado)) {
          mostrar = mostrar && (
            this.facturaNroMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => elementoAux.id == f.factura.numeroComprobante.toString())
          );
        }

        if (this.tipoMultiFiltro.some(elemento => elemento.seleccionado)) {
          mostrar = mostrar && (
            this.tipoMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => Number(elementoAux.id) == f.factura.tipoMovimiento)
          );
        }

        if (this.clienteMultiFiltro.some(elemento => elemento.seleccionado)) {
          mostrar = mostrar && (
            this.clienteMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => elementoAux.id == f.factura.razonSocialCliente)
          );
        }

        if (this.motivoMultifiltro.some(elemento => elemento.seleccionado)) {
          mostrar = mostrar && (
            this.motivoMultifiltro.filter(elemento => elemento.seleccionado).some(elementoAux => Number(elementoAux.id) == f.motivo)
          );
        }

        if (this.solicitadoMultiFiltro.some(elemento => elemento.seleccionado)) {
          mostrar = mostrar && (
            this.solicitadoMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => elementoAux.id == f.usuarioSolicitador)
          );
        }

        if (this.tipoSolicitudMultiFiltro.some(elemento => elemento.seleccionado)) {
          mostrar = mostrar && (
            this.tipoSolicitudMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => Number(elementoAux.id) == f.tipoSolicitud)
          );
        }

        if (this.validadorMultiFiltro.some(elemento => elemento.seleccionado)) {
          mostrar = mostrar && (
            this.validadorMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => elementoAux.id == f.usuarioValidador)
          );
        }

        if (this.revisadoMultiFiltro.some(elemento => elemento.seleccionado)) {
          mostrar = mostrar && (
            this.revisadoMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => elementoAux.id == f.usuarioRevisador)
          );
        }

        if (this.aprobadoMultiFiltro.some(elemento => elemento.seleccionado)) {
          mostrar = mostrar && (
            this.aprobadoMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => elementoAux.id == f.usuarioAprobador)
          );
        }

        return mostrar;

      });
    }
  }

  obtenerTipoMovimiento(tipo: number) {
    return this.tipoMovimientoPipe.transform(tipo);
  }

  obtenerMotivoRefacturacion(numero: string) {
    return Motivo[numero];
  }

  obtenerEstadoRefacturacion(numero: string) {
    return EstadoRefacturacion[numero];
  }

  recargarItems(propiedad: keyof this, items: ItemMultiFiltro[]) {
    (this[propiedad] as ItemMultiFiltro[]) = items;
    this.filtrarFacturasMulti();
  }

  getIsSolicitudReemplazo(tipo: any): boolean {
    return tipo === TipoSolicitudRefacturacion.Reemplazo;
  }

  verComparativasAerovales(contentAerovale, item, index) {
    this.previsualizandoAerovale = true;
    this.itemSeleccionado = index;
    this.tituloAerovale = 'Aerovale: ' + item.aerovalePrefijo+'-'+item.aerovaleNumero + ' Fecha: ' + new Date().toLocaleDateString();
    this.aerovaleService.getPorPrefijoYPorNumero(item.aerovalePrefijo, item.aerovaleNumero)
      .subscribe(aerovaleDetalle => {
        this.aerovaleDetalle = aerovaleDetalle;
        if (item.aerovaleNuevoPrefijo === 0 && item.aerovaleNuevoNumero === 0) {
          this.facturacionService.getObtenerAerovaleReemplazoPendiente(item.aerovaleSolicitanteId)
            .subscribe((aerovaleReemplazo) => {
              this.aerovaleDetalleNuevo = JSON.parse(aerovaleReemplazo.aerovaleReemplazoJson);
              this.previsualizandoAerovale = false;
              this.itemSeleccionado = -1;
              this.modalService.open(contentAerovale, { windowClass: 'custom-modal', centered: true, size: 'lg' });
            });
          } else {
            this.aerovaleService.getPorPrefijoYPorNumero(item.aerovaleNuevoPrefijo, item.aerovaleNuevoNumero)
              .subscribe(aerovaleDetalle => {
                this.aerovaleDetalleNuevo = aerovaleDetalle;
                this.previsualizandoAerovale = false;
                this.itemSeleccionado = -1;
                this.modalService.open(contentAerovale, { windowClass: 'custom-modal', centered: true, size: 'lg' });
              });
          }
      }, (err: ErrorModel) => {
        this.previsualizandoAerovale = false;
        this.itemSeleccionado = -1;
        this.messageService.showErrorMessage('Hubo un error al obtener la comparativa. ' + err.description + ' ' + err.message);
      });
  }

  // roles que solicitan refacturacion de aerovales facturados desde el visor de despacho
  get rolesSolicitanRefacturacion(): boolean {
    return this.rolesService.isSolicitanRefacturacion;
  }

  get busqueda() {
    return this.busquedaFormControl;
  }
}
